module.exports = __webpack_public_path__ + "static/media/bgRanking.88101655.jpg";